import React from 'react'
import styled from 'styled-components'
import ButtonComponent from '../components/ButtonComponent'
import ContentArea from '../components/ContentArea'



const SleepPage = ({ match }) => {
    return (
        <ContentArea home transparent shadowless fullsize>
          <ButtonComponent text="Sleep Hygiene" link="/sleep/hygiene" />
          <ButtonComponent text="Guided Meditation for Sleep/Insomnia" link="/sleep/insomnia" />
        </ContentArea >
      )
}

export default SleepPage
